import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'

import { FilterPropertyType, SearchTitleType } from '../../../types/filter.type'

type RangeType = { from: number | null; to: number | null }

/**
 * Диапазонный фильтр (BPM, цена): два числовых поля «от» и «до».
 * Двухползунковый слайдер сознательно не используется.
 */
@Component({
  selector: 'bmcore-range-filter',
  templateUrl: './bmcore-range-filter.component.html',
  styleUrls: ['./bmcore-range-filter.component.scss'],
  standalone: false
})
export class BmcoreRangeFilterComponent implements OnInit {
  @Input() label: string
  @Input() fromLabel: string
  @Input() toLabel: string
  @Input() filterTitle: SearchTitleType
  @Input() from: number | null = null
  @Input() to: number | null = null
  @Input() min: number = null
  @Input() max: number = null

  @Output() filterTracksEvent = new EventEmitter<FilterPropertyType>()

  private changeSubject = new Subject<RangeType>()

  ngOnInit() {
    this.changeSubject
      .pipe(
        debounceTime(700),
        distinctUntilChanged((a, b) => a.from === b.from && a.to === b.to)
      )
      .subscribe(range => {
        this.filterTracksEvent.emit({ title: this.filterTitle, from: range.from, to: range.to })
      })
  }

  onFromChange(value: string) {
    this.from = this.parse(value)
    this.emit()
  }

  onToChange(value: string) {
    this.to = this.parse(value)
    this.emit()
  }

  private emit() {
    // «от» больше «до» — не шлём запрос, пока пользователь не доправит
    if (this.from !== null && this.to !== null && this.from > this.to) {
      return
    }

    this.changeSubject.next({ from: this.from, to: this.to })
  }

  private parse(value: string): number | null {
    if (value === null || value === undefined || value.trim() === '') {
      return null
    }

    const parsed = Number(value)

    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null
  }
}
